// extracted by mini-css-extract-plugin
export default {"flair":"flair_flair__TOSRF","wrapper":"flair_wrapper__4oDPc"};